import React from 'react';
import {Col} from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';

import './InputNumber.css';

class InputNumber extends AbstractComponent {   
    constructor(props) {
        super(props);

        this.state = {
            keyValid: true,
            input: ''
        }
    }   

    erro() {
        if(Array.isArray(this.props.erro)) {
            return(
                <ul>
                    {this.props.erro.map( (item , i) => {
                        return (
                            <li key={i}>{item}</li>
                        )
                    })}
                </ul>
            )
        }

        return this.props.erro;
    }

    className() {
        return this.props.className !== undefined ? this.props.className : '';
    }    

    classNameInput() {
        return this.props.classNameInput !== undefined ? this.props.classNameInput : '';
    }
    
    classErro() {
        return this.props.erro !== undefined && this.props.erro !== '' ? 'form-controll-erro' : '';
    }    

    teclaSoNum(input) {            
        input = input || window.event;

        var key = input.keyCode || input.which;                        

        if(key === 13) //enter
            return true;            

        if((key === 45)&&(!input.target.value)) // - (menos)
            return true;

        if((key < 48)||(key > 57))
            return false;        

        return true;
    }

    onChange(input) {                 
        if(! this.state.keyValid) {                
            input.target.value = this.state.input;            
            this.setState({keyValid: true});

            return ;              
        } 

        this.setState({input: input.target.value});

        if (this.props.onChange !== undefined) {
          this.props.onChange(input);
        }
    }        

    onKeyPress(input) {                                     
        this.setState({keyValid: this.teclaSoNum(input)});

        if(! this.state.keyValid)             
             return ;        

        if (this.props.onKeyPress !== undefined) {
          this.props.onKeyPress(input);
        }
    }       

    onBlur(input) {        
        if (this.props.onBlur !== undefined) {
          this.props.onBlur(input);
        }
    }    

    invalidCmd(e) {
        e.preventDefault();        
    }

    componentDidMount() {
        if(!this.props.defaultFoco)
            return ;

        this.foco(this.props.nome);
    }

    render() {
        return (
            <Col 
                md={this.props.md} 
                xs={this.props.xs} 
                sm={this.props.sm} 
                lg={this.props.lg}
                style={this.props.style}
            >
                <div className={this.className() + ' ' + this.classErro()} >
                    <label htmlFor={this.props.nome}>
                        {this.props.children}
                    </label>

                    <input 
                        autoComplete="off"                           
                        type={this.props.type} 
                        name={this.props.nome}                            
                        id={this.props.id}     
                        ref={this.props.ref}
                        value={this.props.value}
                        //defaultValue={this.props.defaultValue} 
                        className={"form-control " + this.classNameInput()}
                        disabled={this.props.disabled} 
                        maxLength={this.props.maxLength}                           

                        onPaste={(e) => this.invalidCmd(e)}
                        onDrop={(e) => this.invalidCmd(e)}
                        onChange={input => this.onChange(input)}                                 
                        onKeyPress={input => this.onKeyPress(input)}                           
                        onBlur={e => this.onBlur(e)} 
                    />

                    <span className="help-block">
                        {this.erro()}
                    </span>
                </div>
            </Col>
        )
    }
}

InputNumber.defaultProps = {
    md: 12,
    type: 'number',
    defaultFoco: false
};

export default InputNumber;